import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { getManifestAsync } from '../actions';
import { HostedVideoActions } from '../types';

import { initialHostedVideoState } from './index';

const getManifestReducer: Reducer<typeof initialHostedVideoState, HostedVideoActions> = (
  state = initialHostedVideoState,
  action
) => {
  switch (action.type) {
    case getType(getManifestAsync.request): {
      return {
        ...state,
        getManifest: {
          ...state.getManifest,
          isPending: true,
          isError: false,
          params: {
            hostId: action.payload
          }
        }
      };
    }
    case getType(getManifestAsync.success): {
      const manifest = action.payload.main?.length ? action.payload : { ...action.payload, main: [] };

      return {
        ...state,
        getManifest: {
          ...state.getManifest,
          manifest,
          isPending: false,
          isError: false,
          error: null
        }
      };
    }
    case getType(getManifestAsync.failure): {
      const error = action.payload;
      return {
        ...state,
        getManifest: {
          ...state.getManifest,
          error,
          manifest: null,
          isPending: false,
          isError: true
        }
      };
    }
    default:
      return state;
  }
};

export default getManifestReducer;
